var apiService = require('./api-service');
var apigClientFactory = require('aws-api-gateway-client').default;

export default class SocioData {

  static async getSociogramList (accessToken) {
    try {
      const response = await fetch(`/api/sociogram/list/sociogram`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,  // Pass the token here
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('API error');
      }

      const data = await response.json();
      console.log(data);
      if ( data !== null ) {
        return SocioData.sortByKey(data, "created");
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  // static getSociogramList (callback) {
  //   var config = { invokeUrl: apiService.baseURL }
  //   var apigClient = apigClientFactory.newClient(config);
  //   var params = {};
  //   var pathTemplate = '/api/sociogram/list/sociogram'
  //   var method = 'GET';
  //   var additionalParams = {
  //     headers: {
  //       Authorization: "Bearer " + localStorage.getItem('access_token')
  //     }
  //   };
  //   var body = {
  //   };
    
  //   apigClient.invokeApi(params, pathTemplate, method, additionalParams, body)
  //   .then(function(result){
  //       callback (null, SocioData.sortByKey(result.data, "created"));
  //       return;
  //   }).catch( function(result){

  //     var err = JSON.stringify(result);
  //     if( err.indexOf("401") !== -1 )
  //       callback("You are not authenticated");

  //     // not actually an error, just empty
  //     callback(null,null);
  //     return;
  //   });
  // }

  static async getSociogram(id, accessToken) {
    try {
      // Validate inputs before sending to API
      if (!id || typeof id !== 'string' || !id.trim()) {
        throw new Error('Invalid ID parameter');
      }
      
      if (!accessToken || typeof accessToken !== 'string') {
        throw new Error('Missing or invalid access token');
      }
  
      // Sanitize the ID parameter to prevent path traversal
      const sanitizedId = encodeURIComponent(id.trim());
      
      // Set a timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch(`/api/getsociogram/${sanitizedId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // Helps prevent CSRF
        },
        credentials: 'same-origin', // Only send cookies for same-origin requests
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();
      
      if (data !== "null") {
        return data;
      }
      
      return null;
      
    } catch (error) {
      // Don't expose detailed error messages to console in production
      console.error('Error fetching sociogram data:', error.message);
      
      // Rethrow with generic message for client-side handling
      throw new Error('Failed to fetch sociogram data');
    }
  }

  static async analyse(id, accessToken) {
    try {
      // Validate inputs before sending to API
      if (!id || typeof id !== 'string' || !id.trim()) {
        throw new Error('Invalid ID parameter');
      }
      
      if (!accessToken || typeof accessToken !== 'string') {
        throw new Error('Missing or invalid access token');
      }
  
      // Sanitize the ID parameter to prevent path traversal
      const sanitizedId = encodeURIComponent(id.trim());
      
      // Set a timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch(`/api/analyse/${sanitizedId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // Helps prevent CSRF
        },
        credentials: 'same-origin', // Only send cookies for same-origin requests
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();

      console.log(data);
      
      if (data !== "null") {
        return data;
      }
      
      return null;
      
    } catch (error) {
      // Don't expose detailed error messages to console in production
      console.error('Error fetching sociogram data:', error.message);
      
      // Rethrow with generic message for client-side handling
      throw new Error('Failed to fetch sociogram data');
    }
  }

  // static getSociogram ( id, callback ) {
  //   var config = { invokeUrl: apiService.baseURL }
  //   var apigClient = apigClientFactory.newClient(config);
  //   var params = {};
  //   var pathTemplate = '/api/getsociogram/{id}'
  //   var method = 'GET';
  //   var params = {
  //     //This is where any header, path, or querystring request params go. The key is the parameter named as defined in the API
  //     id: id,
  //   };
  //   var additionalParams = {
  //     headers: {
  //       Authorization: "Bearer " + localStorage.getItem('access_token')
  //     }
  //   };
  //   var body = {
  //   };
    
  //   apigClient.invokeApi(params, pathTemplate, method, additionalParams, body)
  //   .then(function(result){
  //       //This is where you would put a success callback
  //       console.log("Success - " + JSON.stringify(result));
  //       callback (result.data);
  //       return;
  //   }).catch( function(result){
  //     console.log("Fail - " + result);
  //     return;
  //     //This is where you would put an error callback
  //   });
  // }

  static getSociogramUnauthenticated ( id, account, password, callback ) {
    var config = { invokeUrl: apiService.baseURL }
    var apigClient = apigClientFactory.newClient(config);
    var params = {};
    var pathTemplate = '/api/getsociogram/{id}/{pass}/{account}'
    var method = 'GET';
    var params = {
      //This is where any header, path, or querystring request params go. The key is the parameter named as defined in the API
      id: id,
      account: account,
      pass: password,
    };
    var additionalParams = {};
    var body = {};
    //callback(null, {"sociogram":{"version":1,"password":"$2a$10$ODxMeL.il7RO1nMZwgb5c.MNTFgkWijjB9VV9PdPl9q8vh3DDCViW","modifiedAt":1566117606533,"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","people":["hOWfZmRFQ-T2xnWf-u0c0rbg","RoP1PbnrGe3al1FsCkGZpd6M","VpHLs3jGGLnASCOFo4o95JWm","hOWfZmRFQ-T2xnWf-u0c0rbg","RoP1PbnrGe3al1FsCkGZpd6M","VpHLs3jGGLnASCOFo4o95JWm","hOWfZmRFQ-T2xnWf-u0c0rbg","RoP1PbnrGe3al1FsCkGZpd6M","VpHLs3jGGLnASCOFo4o95JWm"],"createdAt":1566117606533,"id":"cMncEuf7BRwF2Fd3X_zZfUKQ","name":"test4"},"people":{"VpHLs3jGGLnASCOFo4o95JWm":{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","surname":"test","id":"VpHLs3jGGLnASCOFo4o95JWm","email":"tes@test.com","givenName":"Test"},"RoP1PbnrGe3al1FsCkGZpd6M":{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","surname":"Bligh2","id":"RoP1PbnrGe3al1FsCkGZpd6M","email":"dan@intervextion.com","givenName":"Daniel2"},"hOWfZmRFQ-T2xnWf-u0c0rbg":{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","surname":"Bligh","id":"hOWfZmRFQ-T2xnWf-u0c0rbg","email":"dan@intervextion.com","givenName":"Daniel"}},"entries":[{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"aalGFe7zL1cDed4yzc2nADcv","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"RoP1PbnrGe3al1FsCkGZpd6M"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"qlhW6Sud8eoy8pDtsKzvTdvE","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"RoP1PbnrGe3al1FsCkGZpd6M"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"ccCBVk57TTcZ3EJxlo7TpeZT","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"VpHLs3jGGLnASCOFo4o95JWm"},{"socioFavourite":"RoP1PbnrGe3al1FsCkGZpd6M","socioData":["VpHLs3jGGLnASCOFo4o95JWm"],"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"nW4EG5NAWe8xWo2iKA7MZZI5","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"hOWfZmRFQ-T2xnWf-u0c0rbg"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"Ps1eNay-NNBe4T8I-MK2QEpt","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"hOWfZmRFQ-T2xnWf-u0c0rbg"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"AXfRVQsZ2fF3LQET0ModeOoN","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"VpHLs3jGGLnASCOFo4o95JWm"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"EcnWY6aJTYiSwBgdzgWmr5H2","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"RoP1PbnrGe3al1FsCkGZpd6M"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"pEPrZNqoGWnOSD7_P1idgbWQ","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"VpHLs3jGGLnASCOFo4o95JWm"},{"accountId":"bj0OliJxl8Sh-TJhamdOeF11:RZ_ZQFK741KNbeUWmU63X30t","id":"Om-5NQkh6nAUhkehLJpR2_Zu","sociogramId":"cMncEuf7BRwF2Fd3X_zZfUKQ","person":"hOWfZmRFQ-T2xnWf-u0c0rbg"}]});
    //return;
    try{
      apigClient.invokeApi(params, pathTemplate, method, additionalParams, body)
      .then(function(result){
          //This is where you would put a success callback
          console.log("Success - " + JSON.stringify(result));
          // alert(result);
          callback (null, result.data);
          return;
      }).catch( function(result){
        console.log("Fail - " + result);
        return;
        //This is where you would put an error callback
      });
    }catch(e){
      alert(e);
    }
  }

  static async createSociogram(data, accessToken) {
    try {
      // Validate inputs
      if (!data) {
        throw new Error('Invalid data parameter');
      }
      
      if (!accessToken || typeof accessToken !== 'string') {
        throw new Error('Missing or invalid access token');
      }
  
      // Set a timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch('/api/sociogram/create', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // Helps prevent CSRF
        },
        credentials: 'same-origin',
        body: JSON.stringify(data),
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      const responseData = await response.json();
      return "Successfully created Sociogram";
      
    } catch (error) {
      console.error('Error creating sociogram:', error.message);
      throw new Error('Failed to create Sociogram');
    }
  }

  static async updateSociogram(sociogramId, data, accessToken) {
    try {
      // Validate inputs
      if (!data) {
        throw new Error('Invalid data parameter');
      }
      
      if (!accessToken || typeof accessToken !== 'string') {
        throw new Error('Missing or invalid access token');
      }
  
      // Set a timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch('/api/sociogram/' + sociogramId, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // Helps prevent CSRF
        },
        credentials: 'same-origin',
        body: JSON.stringify(data),
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      const responseData = await response.json();
      return "Successfully updated Sociogram";
      
    } catch (error) {
      console.error('Error updating sociogram:', error.message);
      throw new Error('Failed to update Sociogram');
    }
  }

  static async deleteSociogram(id, accessToken) {
    try {
      // Validate inputs
      if (!id) {
        throw new Error('Invalid data parameter');
      }
      
      if (!accessToken || typeof accessToken !== 'string') {
        throw new Error('Missing or invalid access token');
      }
  
      // Set a timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch('/api/sociogram/delete/' + id, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // Helps prevent CSRF
        },
        credentials: 'same-origin',
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      return "Successfully deleted Sociogram";
      
    } catch (error) {
      console.error('Error deleted sociogram:', error.message);
      throw new Error('Failed to deleted Sociogram');
    }
  }

  // static createSociogram( data, callback ){
  //   var config = { invokeUrl: apiService.baseURL }
  //   var apigClient = apigClientFactory.newClient(config);
  //   var pathTemplate = '/api/sociogram/create'
  //   var method = 'POST';
  //   var additionalParams = {
  //     headers: {
  //       Authorization: "Bearer " + localStorage.getItem('access_token')
  //     }
  //   };
  //   const peopleList = this.peopleList;
  //   apigClient.invokeApi({}, pathTemplate, method, additionalParams, data)
  //   .then(function(result){
  //     callback(null, "Successfully created Sociogram");
  //   }).catch( function(result){
  //     console.log("Fail - " + result);
  //     callback(null, "Failed to create Sociogram");
  //   });
  // }

  static sortByKey(array, key) {
      return array.sort(function(a, b) {
          var x = a[key]; var y = b[key];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
  }
}